import { apiFetch } from './httpClient';

async function createActivationEvent(eventName, eventProperties = {}) {
  const response = await apiFetch('/api/activation/events', {
    method: 'POST',
    body: JSON.stringify({
      event_name: eventName,
      event_properties: eventProperties,
    }),
  });

  const result = await response.json();

  if (!response.ok || !result.ok) {
    throw new Error(result?.error || result?.detail || `Failed to track ${eventName}`);
  }

  return result.data;
}

export const activationService = {
  createActivationEvent,

  trackEvent(eventName, eventProperties = {}) {
    return createActivationEvent(eventName, eventProperties).catch((error) => {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('[Activation] Failed to track event:', eventName, error);
      }
      return null;
    });
  },
};
